import type { ReactNode } from 'react'

import { createContext, use, useState } from 'react'

type OpenContextType = {
	isOpen: (id: string) => boolean
	toggle: (id: string) => void
}

const OpenStateContext = createContext<OpenContextType>({
	isOpen: () => false,
	toggle: () => {},
})

export const OpenStateProvider = ({ children }: { children: ReactNode }) => {
	const [openIds, setOpenIds] = useState<Record<string, boolean>>({})
	const toggle = (id: string) => {
		setOpenIds((prev) => ({
			...prev,
			[id]: !prev[id],
		}))
	}
	const isOpen = (id: string) => !!openIds[id]

	return (
		<OpenStateContext value={{ isOpen, toggle }}>{children}</OpenStateContext>
	)
}

export function useOpenStateContext() {
	return use(OpenStateContext)
}
